<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Add Article",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Add Article",
            items: [
               {
                  text: "Articles",
                  href: "/articles",
               },
               {
                  text: "Add Article",
                  active: true,
               },        
            ],

            article: {
               title: '',
               content: '',
               category_id: '',
               author_id: '',               
            },

            image: '',
            preview_image: '',

            categories: [],
            authors: [],

            token: "",
            errors: {},
            loading: false,
         };
      },
      mounted() {
    
      },

      created() {
         this.fetchCategories();
         this.fetchAuthors();

      },

      methods: {    

         getToken() {
            if (localStorage.getItem('sigomind_admin')) {
               var sigomind_admin =  JSON.parse(localStorage.getItem('sigomind_admin'));
               if(sigomind_admin.token) {
                  this.token = sigomind_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchCategories() {
            let url = "admin/get-categories?type=1";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.categories = responseData.categories;
               })
               .catch((err) => console.log(err));
         },

         fetchAuthors() {
            let url = "admin/get-authors?type=1";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.authors = responseData.authors;
               })
               .catch((err) => console.log(err));
         },

         setFile(event) {
            this.image = event.target.files[0];
            this.preview_image = URL.createObjectURL(this.image);     
         },

         addArticle() {
            this.getToken();            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let formData = new FormData();
            formData.append("title", this.article.title);
            formData.append("content", this.article.content);
            formData.append("category_id", this.article.category_id);
            formData.append("author_id", this.article.author_id);

            formData.append("image", this.image);

            let url = 'admin/articles/create';
            this.active_page_url = null;  
            
                      
            this.loading = true;

            this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.$router.push({ name: 'articles'});
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },

         clearForm() {          
           
            this.article.title = "";               
            this.article.category_id = "";        
            this.article.author_id = "";     
            this.article.content = "";

            this.image = "";
            this.preview_image = "";

            this.errors = {};
         },
         
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'articles' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent="addArticle()">
                        <div class="row"> 

                           <b-form-group class="col-lg-12">
                              <label>Title<span class="text-danger">*</span></label>
                              <b-form-input v-model="article.title" v-bind:class="{ 'is-invalid': Boolean(errors.title) }"></b-form-input>

                              <div v-for="(val, index) in errors.title" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>  
                           </b-form-group>   


                           <b-form-group class="col-lg-12">
                              <label>Content<span class="text-danger">*</span></label>

                              <b-form-textarea rows="5" v-model="article.content" v-bind:class="{ 'is-invalid': Boolean(errors.content) }"></b-form-textarea>

                              <div v-for="(val, index) in errors.content" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>  
                           </b-form-group>

                           <b-form-group class="col-lg-6">
                              <label>Category <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="article.category_id" v-bind:class="{ 'is-invalid': Boolean(errors.category_id) }">
                                 <option value="">Select Category</option>
                                 <option :value="category.id" v-for="category in categories" :key="category.id">{{category.category}}</option>
                              </select>

                              <div v-for="(val, index) in errors.category_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>   

                           <b-form-group class="col-lg-6">
                              <label>Author <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="article.author_id" v-bind:class="{ 'is-invalid': Boolean(errors.author_id) }">
                                 <option value="">Select Author</option>
                                 <option :value="author.id" v-for="author in authors" :key="author.id">{{author.author}}</option>
                              </select>

                              <div v-for="(val, index) in errors.author_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>        
                           
                        </div>

                        <div class="row">
                           <div class="col-lg-6 mb-3">
                              <label>Image</label>
                           
                              <input type="file" @change="setFile" accept=".png,.jpg,.jpeg" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.image) }" />
                              

                              <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                           </div>

                           <div class="col-lg-6 mb-3">
                              <img class="image-preview mt-2" v-bind:src="preview_image">
                           </div>
                        </div>

                        <div class="row mt-3">
                           <div class="12">
                              <button class="btn btn-primary me-2" type="submit">Save</button>
                              <router-link :to="{ name: 'articles' }" class="btn btn-light">Cancel</router-link>
                           </div>
                        </div>
                     </form>
                  </b-card>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
